import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { WebPageService, WebPageSubscriptionEditGet } from '@app/services/web-page.service';

@Component({
    selector: 'tt-webpage-subscription-edit',
    templateUrl: './webpage-subscription-edit.component.html',
    styleUrls: ['./webpage-subscription-edit.component.css'],
    standalone: false,
})
export class WebpageSubscriptionEditComponent implements OnInit, OnChanges {
    @Input()
    public p2WebpageSubscriptionKeyno?: string | number;

    @Output()
    public onSave = new EventEmitter<void>();

    public page?: WebPageSubscriptionEditGet;

    public saving = false;

    public readonly tabletSize: MediaQueryList;

    private loadVersion = 0;

    constructor(
        private webPage: WebPageService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;

        this.saving = true;

        try {
            await this.webPage.saveWebPageSubscription(this.page);
            this.saving = false;

            if (this.tabletSize.matches && this.onSave.observed) {
                this.onSave.emit();
            } else {
                await this.navigator?.back();
            }
        } catch {
            // DataTask reports the error; keep the editor open for a retry.
        } finally {
            this.saving = false;
        }
    }

    public ngOnInit(): void {
        if (this.p2WebpageSubscriptionKeyno !== undefined && this.p2WebpageSubscriptionKeyno !== null) return;

        const keyno = this.navigator?.params['p2_webpage_subscription_keyno'];
        if (typeof keyno === 'string' || typeof keyno === 'number') void this.loadPage(keyno);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['p2WebpageSubscriptionKeyno'] && this.p2WebpageSubscriptionKeyno !== undefined && this.p2WebpageSubscriptionKeyno !== null) {
            void this.loadPage(this.p2WebpageSubscriptionKeyno);
        }
    }

    private async loadPage(keyno: string | number): Promise<void> {
        if (keyno === '') return;

        const version = ++this.loadVersion;
        this.page = undefined;
        const page = await this.webPage.getWebPageSubscriptionEdit({ p2_webpage_subscription_keyno: keyno });
        if (version === this.loadVersion) this.page = page;
    }
}
